import { auth$, onTokenChange } from '@creditsights/api-ui-web';
import { useEffect, useState } from 'react';
import { QueryClient } from 'react-query';

interface UseIsAuthenticatedResult {
  isAuthenticated: boolean;
  setIsAuthenticated: (value: boolean) => void;
}

const useIsAuthenticated = (queryClient: QueryClient): UseIsAuthenticatedResult => {
  const [isAuthenticated, setIsAuthenticated] = useState(!!auth$.value);

  useEffect(() => {
    auth$.subscribe((token) => {
      // clears all existing cache if user logs out
      if (!token) {
        queryClient.clear();
      }
      setIsAuthenticated(!!token);
      onTokenChange(token);
    });
  }, []);

  return {
    isAuthenticated,
    setIsAuthenticated,
  };
};

export default useIsAuthenticated;
